window.Products.DeviceCase.GalaxyS6 = function() {
};
window.Products.DeviceCase.GalaxyS6.inherits(window.Products.DeviceCase.DeviceCase);
window.Products.DeviceCase.GalaxyS6.id = 55;
window.Products.DeviceCase.GalaxyS6.slug = 'galaxy-s6';

window.Products.DeviceCase.GalaxyS6.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.y = -0.7;
	modelViewer.camera.position.z = 8;
};

window.Products.DeviceCase.GalaxyS6.prototype.setThreeControls = function(controls) {
	controls.minDistance = 3.4;
	controls.maxDistance = 4.4;
};